import {Directive, TemplateRef} from '@angular/core';

@Directive({
  selector: '[appUploaderHeader]'
})
export class UploaderHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {
  }
}
